export const RolesKey = 'roles';
export const ActiveRolesKey = 'active-roles';
export const RolePermissionsKey = 'role-permissions';